import { render, staticRenderFns } from "./IpsSpinner.vue?vue&type=template&id=55e0e671&scoped=true"
import script from "./IpsSpinner.vue?vue&type=script&lang=js"
export * from "./IpsSpinner.vue?vue&type=script&lang=js"
import style0 from "./IpsSpinner.vue?vue&type=style&index=0&id=55e0e671&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e0e671",
  null
  
)

export default component.exports